import compose from "ramda/es/compose";
import map from "ramda/es/map";
import memoizeWith from "ramda/es/memoizeWith";
import when from "ramda/es/when";
import argumentsToList from "ramda-extension/es/argumentsToList";
import isObject from "ramda-extension/es/isObject";
import listToString from "ramda-extension/es/listToString";
/**
 * Function for memoize functions with more than one arguments
 *
 * NOTE: For memoize function with only one parameters use `memoizeWithIdentity` from ramda-extension
 *
 * @documented
 * @category Function
 * @example
 *
 * 		memoizeWithAllArguments((1, 2, 3) => 1 + 2 + 3) // => one expensive calculation later => 6
 */ const memoizeWithAllArguments = (fn)=>memoizeWith(compose(listToString, map(when(isObject, JSON.stringify)), argumentsToList), fn);
export default memoizeWithAllArguments;
